import moment from 'moment';
export default function formatPredict(predict, baseTime) {
  const baseTimeMoment = moment(baseTime);
  if (predict === 0) {
    const result = baseTimeMoment.utc();
    return [result.format('MMM DD, HH'), result.format('mm'), true]
  }

  const currentTime = baseTimeMoment.add(predict / 60, 'hours').utc();
  if (currentTime.hour() === 0) return [currentTime.format('MMM DD, HH'), currentTime.format('mm'), true];

  return [currentTime.format('HH'), currentTime.format('mm'), false];
}